// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HhmH","rootNoMargin":"styles_rootNoMargin__26ACo"};